import { formatISO } from "date-fns";

import { SurveyFilters } from "./components/SurveyFilterPanel";

export const getFiltersForSearchService = (filters: SurveyFilters, searchTerm?: string) => {
	const result: Record<string, unknown> = {
		name_re: searchTerm,
	};

	if (filters.status) {
		result.status_in = [filters.status];
	}

	if (filters.startDateGte) {
		result.start_date_gte = formatISO(filters.startDateGte);
	}

	if (filters.startDateLte) {
		result.start_date_lte = formatISO(filters.startDateLte);
	}

	if (filters.endDateGte) {
		result.end_date_gte = formatISO(filters.endDateGte);
	}

	if (filters.endDateLte) {
		result.end_date_lte = formatISO(filters.endDateLte);
	}

	if (filters.createdBy) {
		result.created_user_id_eq = filters.createdBy.id;
	}

	return result;
};
